import { memo, useMemo } from 'react';
import shallow from 'zustand/shallow';
import { Dropdown, DropdownItem } from '../../../components/Dropdown';
import { getBlockFormat, getBlockMetadata } from '../../../editorTools/queries';
import { setBlockType } from '../../../editorTools/transforms';
import { useTPlateEditorRef } from '../../../plate';
import { getSelectedElementEntry } from '../../../plugins/elementSelection';
import { useDreamEditorStore } from '../../../plugins/store';
import { getAllBlockTypeOptions } from '../queries';
import styles from '../SideToolbar.module.css';

function BlockType() {
  const editor = useTPlateEditorRef();

  const allOptions = useMemo(() => getAllBlockTypeOptions(editor), [editor]);

  const [label, filteredOptions] = useDreamEditorStore(() => {
    const entry = getSelectedElementEntry(editor);

    if (!entry) return ['', []];

    const { type } = entry[0];

    const format = getBlockFormat(editor, { type });
    const metadata = getBlockMetadata(editor, { type });

    const options = format?.turnInto
      ? allOptions.filter((o) => format.turnInto?.includes(o.type))
      : allOptions;

    return [metadata?.title, options];
  }, shallow);

  return (
    <div className={styles.section}>
      <span className={styles.label}>Block Type</span>
      <Dropdown
        triggerLabel={label || 'Select a Block'}
        disabled={filteredOptions.length === 0}
      >
        {Object.values(filteredOptions).map((opt) => (
          <DropdownItem key={opt.type}>
            <div
              role="none"
              className="is-capitalized"
              onMouseDown={() => {
                const path = getSelectedElementEntry(editor)?.[1];
                if (path) {
                  setBlockType(editor, opt.type, { at: path });
                }
              }}
            >
              {opt.title || opt.type}
            </div>
          </DropdownItem>
        ))}
      </Dropdown>
    </div>
  );
}

export default memo(BlockType);
